const steps = [
  {
    disableBeacon: true,
    target: '.site-breadcrumbs',
    title: 'Breadcrumbs',
    content: 'Usa questa barra di navigazione per muoverti velocemente tra le pagine',
    placement: "bottom",
  },
  {
    target: '.category-card',
    title: 'Categoria',
    content: 'Clicca su una categoria per accedere alla dashboard',
    placement: "bottom-start",
  },
];

export default steps;
